import { BASE_URL } from "@src/constants/apiEndpoints";

export const handleCostcoAdminSSO = () => {
  localStorage.removeItem('costcoAdminToken');
  const hostname = window.location.hostname;
  const trimmedHost = hostname.split('.').slice(0, -1).join('.');
  const url = `${BASE_URL}/api/v1/mvt/auth/sso?redirect=${trimmedHost}&page=ADMIN`;
  console.log('Redirecting to Costco ADMIN SSO:', url);
  window.location.href = url;
};